import Microgame from '../engine/Microgame.js';

export default class DunkGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Dunk !`, en: `Dunk!`, es: `¡Encesta!` },
            controls: { fr: `Appuie au bon moment (ou glisse) pour smasher`, en: `Tap at the exact right time to smash`, es: `Toca en el momento exacto para machacar` },
            objective: { fr: `Rentre la balle violemment dans le panier`, en: `Slam the ball violently into the hoop`, es: `Mete la bola violentamente en el aro` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/><polyline points="16 6 12 2 8 6"/><line x1="12" y1="2" x2="12" y2="15"/></svg>`,
            actions: [
                { type: 'wait', duration: 460 },
                { type: 'tap', x: 50, y: 58, duration: 180 },
                { type: 'wait', duration: 700 },
            ],
            loopDuration: 2800
        };
    }
    constructor(engine) {
        super(engine);
        this.cookie = null;
        this.glass = null;
        this.milk = null;
        this.isDropped = false;
        
        this.cookieX = 50; 
        this.cookieY = 15; 
        
        this.angle = this.isPlayback ? 0 : (Math.random() * Math.PI * 2); 

        // Difficulty scaling
        const speedMult = engine.speedMultiplier || 1.0;
        const adjustedSpeedScale = 1 + (speedMult - 1) * 1.0; // Ensures exactly 1s at x4
        this.duration = 4000 * (speedMult / adjustedSpeedScale);
        
        this._isAnimating = false;
        this._frozenTimerValue = 0;
        
        // Swing Speed scaling
        this.swingSpeed = 2.5 * (1 + (speedMult - 1) * 0.5); // Slightly faster at max speed
    }

    setup() {
        this.engine.ui.instruction.textContent = "DUNK IT!";

        // Glass (Back & Fill)
        this.glass = document.createElement('div');
        this.glass.style.position = 'absolute';
        this.glass.style.width = '130px';
        this.glass.style.height = '150px';
        this.glass.style.border = `6px solid ${this.secondaryColor}`;
        this.glass.style.borderTop = 'none';
        this.glass.style.bottom = '15%';
        this.glass.style.left = '50%';
        this.glass.style.transform = 'translateX(-50%)';
        this.glass.style.borderRadius = '0 0 25px 25px';
        this.glass.style.boxShadow = `0 10px 30px rgba(0,0,0,0.5), 0 0 20px ${this.secondaryColor}`;
        this.glass.style.overflow = 'hidden';
        this.glass.style.zIndex = '2';
        this.container.appendChild(this.glass);

        this.milk = document.createElement('div');
        this.milk.style.position = 'absolute';
        this.milk.style.width = '100%';
        this.milk.style.height = '75%';
        this.milk.style.background = this.secondaryColor;
        this.milk.style.bottom = '0';
        this.milk.style.opacity = '0.9';
        this.glass.appendChild(this.milk);

        // Cookie (Dropper)
        this.cookie = document.createElement('div');
        this.cookie.style.position = 'absolute';
        this.cookie.style.width = '70px';
        this.cookie.style.height = '70px';
        this.cookie.style.background = this.primaryColor;
        this.cookie.style.borderRadius = '50%';
        this.cookie.style.top = `${this.cookieY}%`;
        this.cookie.style.left = `${this.cookieX}%`;
        this.cookie.style.transform = 'translate(-50%, -50%)';
        this.cookie.style.boxShadow = `0 0 15px ${this.primaryColor}`;
        this.cookie.style.zIndex = '5'; // Between back and front of the glass!
        
        // Add chocolate chips for detail
        for (let i = 0; i < 6; i++) {
            const chip = document.createElement('div');
            chip.style.position = 'absolute';
            chip.style.width = '12px';
            chip.style.height = '12px';
            chip.style.background = '#222';
            chip.style.borderRadius = '50%';
            chip.style.top = `${Math.random() * 45 + 5}px`;
            chip.style.left = `${Math.random() * 45 + 5}px`;
            this.cookie.appendChild(chip);
        }
        this.container.appendChild(this.cookie);

        // Glass Front (Creates the 3D optical illusion)
        this.glassFront = document.createElement('div');
        this.glassFront.style.position = 'absolute';
        this.glassFront.style.width = '130px';
        this.glassFront.style.height = '150px';
        this.glassFront.style.border = `6px solid ${this.secondaryColor}`;
        this.glassFront.style.borderTop = 'none';
        this.glassFront.style.bottom = '15%';
        this.glassFront.style.left = '50%';
        this.glassFront.style.transform = 'translateX(-50%)';
        this.glassFront.style.borderRadius = '0 0 25px 25px';
        this.glassFront.style.pointerEvents = 'none';
        this.glassFront.style.zIndex = '10'; // In front of the cookie!
        this.container.appendChild(this.glassFront);


        this.onTap = this.onTap.bind(this);
        this.engine.input.element.addEventListener('pointerdown', this.onTap);
    }

    update(dt) {
        // Freeze timer visually
        if (this._isAnimating) {
            this.engine.timer = Math.max(0, this._frozenTimerValue);
        }

        if (this.won || this.lost) return;

        if (!this.isDropped) {
            // Swing cookie left and right
            this.angle += this.swingSpeed * (dt / 1000);
            this.cookieX = 50 + Math.sin(this.angle) * 35;
            this.cookie.style.left = `${this.cookieX}%`;
        }
    }

    onTap() {
        if (this.won || this.lost || this.isDropped) return;
        this.isDropped = true;
        
        this._isAnimating = true;
        this._frozenTimerValue = this.engine.timer;

        const containerRect = this.container.getBoundingClientRect();
        const glassRect = this.glass.getBoundingClientRect();
        
        const containerWidth = containerRect.width || window.innerWidth;
        const containerHeight = containerRect.height || window.innerHeight;
        const cookieXPixels = (this.cookieX / 100) * containerWidth;
        const centerXPixels = containerWidth / 2;
        const offCenterPixels = Math.abs(cookieXPixels - centerXPixels);

        // Dynamically calculate EXACT glass rim height in %
        const rimPixelY = glassRect.top - containerRect.top;
        const rimCookieCenterPixelY = rimPixelY - 34; // cookie radius 35, minus 1px overlap
        const rimPct = (rimCookieCenterPixelY / containerHeight) * 100;
        
        // Milk height % (for inside glass drops)
        const milkPct = rimPct + 12; 

        // Transition physics
        this.cookie.style.transition = 'top 0.3s ease-in, left 0.3s ease-in, transform 0.3s ease';

        // Collision logic
        // Glass outer radius ~71px
        // Cookie radius: 35px.
        // Full overlap threshold = 71 + 35 = 106px.
        
        if (offCenterPixels <= 24) {
            // 1. Clean drop directly in the middle (Win)
            this.cookie.style.transition = 'top 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53)';
            this.cookie.style.top = `${milkPct}%`; 
            setTimeout(() => {
                this.createSplash();
                this.cookie.style.top = `${milkPct + 5}%`;
                this.cookie.style.transform = 'translate(-50%, -50%) scale(0.8)';
                this.cookie.style.opacity = '0.4';
                setTimeout(() => this.win(), 200);
            }, 400);

        } else if (offCenterPixels <= 50) {
            // 2. Inner rim collision (Bounces IN to win)
            // Stop exactly on the glass rim
            this.cookie.style.top = `${rimPct}%`; 
            const tilt = this.cookieX > 50 ? 20 : -20;
            this.cookie.style.transform = `translate(-50%, -50%) rotate(${tilt}deg)`; 
            
            setTimeout(() => {
                // Bounce towards the milk
                this.cookie.style.transition = 'top 0.2s ease-in, left 0.2s linear, transform 0.2s';
                this.cookie.style.left = '50%'; 
                this.cookie.style.top = `${milkPct}%`;
                this.cookie.style.transform = 'translate(-50%, -50%) rotate(0deg) scale(0.8)';
                
                setTimeout(() => {
                    this.createSplash();
                    this.cookie.style.top = `${milkPct + 5}%`;
                    this.cookie.style.opacity = '0.4';
                    setTimeout(() => this.win(), 200);
                }, 200);
            }, 300);

        } else if (offCenterPixels <= 106) {
            // 3. Outer rim collision (Bounces OUT to lose) - captures all visual clipping overlaps
            this.cookie.style.top = `${rimPct}%`; 
            const tilt = this.cookieX > 50 ? -30 : 30; // Tip outward
            this.cookie.style.transform = `translate(-50%, -50%) rotate(${tilt}deg)`;
            
            setTimeout(() => {
                // Deflect outward in a fall
                this.cookie.style.transition = 'top 0.4s ease-in, left 0.4s linear, transform 0.4s';
                const deflection = this.cookieX > 50 ? 40 : -40; // Push out
                this.cookie.style.left = `calc(${this.cookieX}% + ${deflection}px)`;
                this.cookie.style.top = '120%';
                setTimeout(() => this.lose(), 400);
            }, 300);

        } else {
            // 4. Complete miss
            this.cookie.style.transition = 'top 0.5s cubic-bezier(0.55, 0.085, 0.68, 0.53)';
            this.cookie.style.top = '120%';
            setTimeout(() => {
                this.lose();
            }, 500);
        }
    }

    createSplash() {
        const splash = document.createElement('div');
        splash.style.position = 'absolute';
        splash.style.width = '100px';
        splash.style.height = '40px';
        splash.style.background = this.secondaryColor;
        splash.style.bottom = '25%'; 
        splash.style.left = '50%';
        splash.style.transform = 'translate(-50%, 50%) scale(0)';
        splash.style.borderRadius = '50%';
        splash.style.zIndex = '10';
        this.container.appendChild(splash);

        splash.animate([
            { transform: 'translate(-50%, 50%) scale(0)', opacity: 1 },
            { transform: 'translate(-50%, 50%) scale(1.5)', opacity: 0 }
        ], {
            duration: 400,
            easing: 'ease-out'
        });
    }

    cleanup() {
        super.cleanup();
        this.engine.input.element.removeEventListener('pointerdown', this.onTap);
    }
}
